module.exports = __webpack_public_path__ + "img/Festival-text.90cbd200.jpg";